import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Toast } from 'antd-mobile'
import commonAction from '../../actions/common'
import { getMyTodoList } from '../../api/MyTask'
import ScrollBox from '../../components/ScrollBox'
import NoData from '../../components/NoData'
import Lodding from '../../components/Lodding'
import './index.scss'

class MyTask extends Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      animating: false,
      isCanLoading: true,
      scrollHight: 0,
    }
  }

  componentDidMount() {
    this.fetchList()
    setTimeout(() => {
      this.setState({ scrollHight: window.innerHeight - 130 })
    }, 100)
  }

  fetchList = async () => {
    this.setState({ animating: true })
    try {
      const res = await getMyTodoList()
      if (res.code === 200) {
        this.setState({ list: res.data || [], animating: false })
      } else {
        this.setState({ animating: false })
        Toast.fail((res && res.message) || '请求失败', 1)
      }
    } catch (e) {
      this.setState({ animating: false })
      Toast.fail('请求失败', 1)
    }
  }

  handleRefresh = () => {
    this.fetchList()
  }

  render() {
    const { list, animating, scrollHight } = this.state
    return (
      <div className="my-task-page commonBodyBox">
        <div className="my-task-scroll" style={{ height: scrollHight || '70vh' }}>
          <ScrollBox onRefresh={this.handleRefresh} onLoadMore={() => {}}>
            {list.length ? (
              <ul className="my-task-list">
                {list.map(item => (
                  <li className="mt-card" key={item.id}>
                    <div className="mt-head">
                      <span className="mt-badge">待完成</span>
                      {item.projectTitle ? <span className="mt-project">{item.projectTitle}</span> : null}
                      {item.stageName ? <span className="mt-stage">第 {item.stage} 步 · {item.stageName}</span> : null}
                    </div>
                    <div className="mt-content">{item.content}</div>
                    {item.createTime ? <div className="mt-time">指派时间：{item.createTime}</div> : null}
                  </li>
                ))}
              </ul>
            ) : (
              <div className="null-wrap">
                {animating ? <Lodding /> : <NoData text="暂无指派任务" />}
              </div>
            )}
            <div style={{ height: 40 }} />
          </ScrollBox>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({ commonState: state.commonState }),
  dispatch => ({ commonAction: commonAction.bind(dispatch) })
)(MyTask)